import { RouteConfig } from 'vue-router'
import VueI18n from 'vue-i18n'

const CatalogParamsView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/CatalogParamsView.vue')
const SaleCategoryListView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/SaleCategoryListView.vue')
const ChargesCategoryListView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/ChargesCategoryListView.vue')
const ProductVariationListView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/ProductVariationListView.vue')
const StockParamsView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/StockParamsView.vue')
const CustomPricesSalesCategoriesView: DynamicImport = () => import(/* webpackChunkName: "catalog" */ '../views/CustomPricesSalesCategoriesView.vue')

const routes: (i18n: VueI18n) => Array<RouteConfig> = (i18n) => ([
  {
    name: 'sales-sales-categories',
    path: 'sales/sales-categories',
    component: SaleCategoryListView,
    meta: {
      title: i18n.t('catalog.saleCategory.pageTitle')
    }
  },
  {
    name: 'sales-catalog',
    path: 'sales/catalog',
    component: CatalogParamsView,
    meta: {
      title: i18n.t('catalog.params.pageTitle')
    }
  },
  {
    name: 'sales-product-variations',
    path: 'sales/product-variations',
    component: ProductVariationListView,
    meta: {
      title: i18n.t('catalog.productVariations.pageTitle'),
      appModule: 'catalog-variations'
    }
  },
  {
    name: 'sales-custom-prices',
    path: 'sales/custom-prices',
    component: CustomPricesSalesCategoriesView,
    meta: {
      title: 'Prix personnalisés',
      appModule: 'catalog-custom-prices'
    }
  },
  {
    name: 'charges-charge-categories',
    path: 'charges/charge-categories',
    component: ChargesCategoryListView,
    meta: {
      title: i18n.t('catalog.chargeCategory.pageTitle')
    }
  },
  {
    name: 'stock-params',
    path: 'stock-params',
    component: StockParamsView,
    meta: {
      title: i18n.t('catalog.config.pageTitle'),
      appModule: 'stock'
    }
  }
])

export default routes
